import React from 'react';

interface MobileStickyBottomProps {
  children: React.ReactNode;
}

const MobileStickyBottom: React.FC<MobileStickyBottomProps> = ({ children }) => {
  return (
    <div className="fixed block md:hidden bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 p-3 md:p-4 mobile-menu-bottom">
      {children}
    </div>
  );
};

export default MobileStickyBottom;